import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../services/itinerary.service';
import { OperationLogService } from '../services/operation-log.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

@Injectable({ providedIn: 'root' })
export class PnrHistoryGuard implements CanActivate {
  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private operationService: OperationLogService,
    private layoutService: LayoutService
  ) {}

  private loadHistory(
    pnr: string,
    officeId: string,
    country: string,
    gds: string,
    bookingCode: string
  ) {
    const loadHistories = forkJoin({
      pnrHistory: this.api.getPNRHistory(pnr, officeId, country, gds, bookingCode),
      pnrItineraryHistory: this.api.getPNRItineraryHistory(pnr, officeId, country, gds)
    });

    return loadHistories.pipe(
      map(
        (res) => {
          this.layoutService.dispatchChangeBreadcrumb(pnr, OptionType.History);
          this.operationService.dispatchLoadHistorySuccess(res.pnrHistory);
          this.operationService.dispatchLoadItineraryHistorySuccess(res.pnrItineraryHistory);
          return true;
        },
        catchError((response) => {
          this.itineraryService.dispatchGenericError(response);
          this.itineraryService.navigateToWithParams('itinerary/info');
          return of(false);
        })
      )
    );
  }

  canActivate(route?: ActivatedRouteSnapshot) {
    return this.loadHistory(
      route?.queryParams?.pnr,
      route?.queryParams?.officeId,
      route?.queryParams?.country,
      route?.queryParams?.gds,
      route?.queryParams?.bookingCode
    );
  }
}
